//

import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";

export default {
    name: "ScPluginDescription",
    components: {
        AQButton,
        AQMenu
    },
    data() {
        return {
            menuOptions: [
                {
                    label: "Action 1"
                },
                {
                    label: "Action 2"
                }
            ],
            menu: []
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", [
            "selectedPluginCode",
            "selectedPluginInformationData"
        ]),
        ...mapGetters("diagrams", ["getConnectorsValidation"]),
        details() {
            const vm = this;
            const details = {};

            if (vm.getConnectorsValidation.length) {
                details.description = vm.getConnectorsValidation.length + vm.$t("diagrams.components.setTarget.noLabelConnector");
                details.objectName = this.$t("generic.warning");
                details.iconColor = "red";
            }
            if (!this.selectedPluginCode && !vm.getConnectorsValidation.length) {
                details.description = this.$t(
                    "diagrams.pluginDescription.noPluginSelected"
                );
                details.objectName = this.$t("diagrams.pluginDescription.noneSelected");
                details.iconColor = "#256BDE";
            } else {
                const self = this;
                const pluginInfo = this.selectedPluginInformationData.find((
                    plugin
                ) => plugin.id === self.selectedPluginCode);
                details.description = pluginInfo.description;
                details.objectName = pluginInfo.name;
                details.iconColor = pluginInfo.color;
            }
            return details;
        }
    }
};
